import { Button, DateRangePicker, RadioGroup } from 'vnetwork-ui'
import dayjs, { Dayjs } from 'dayjs'
import { Controller, useForm, UseFormSetValue } from 'react-hook-form'
import {
    DayOffNewPayload,
    DayOffRangeTime,
} from '@/modules/Dayoffs/types/payload'

interface DayOffRangeTimeFromProps {
    onClose: () => void
    setValue: UseFormSetValue<DayOffNewPayload>
    watch: (value: string) => DayOffRangeTime[]
    append: (value: DayOffRangeTime) => void
}

interface DayOffRange {
    dayOffRange: [startDay: Dayjs, endDay: Dayjs]
    option: 0 | 1 | 2
}
const DayOffRangeTimeFrom: React.FC<DayOffRangeTimeFromProps> = ({
    setValue,
    watch,
    append,
    onClose,
}) => {
    const { control: dateRangeForm, handleSubmit: handleCreateDateRange } =
        useForm<DayOffRange>({
            defaultValues: {
                dayOffRange: [],
                option: 0,
            },
        })

    const createRangeOptions = async (data: DayOffRange) => {
        const { dayOffRange, option } = data
        let currentDay = dayOffRange[0]
        const list = watch('day_off.day_off_range_time')?.map((child) =>
            dayjs(child?.start_day_off)?.format('YYYY-MM-DD')
        )
        const daysCount = dayOffRange[1].diff(dayOffRange[0], 'day')
        for (let i = 0; i <= daysCount; i++) {
            if (!list?.includes(currentDay?.format('YYYY-MM-DD') || '')) {
                append({
                    start_day_off: currentDay.format('YYYY-MM-DD').toString(),
                    day_off_option: option,
                })
            } else {
                const index = watch('day_off.day_off_range_time')?.findIndex(
                    (item) =>
                        dayjs(item?.start_day_off).format('YYYY-MM-DD') ===
                        currentDay?.format('YYYY-MM-DD')
                )
                if (index !== -1) {
                    setValue(
                        `day_off.day_off_range_time.${index}.day_off_option`,
                        option
                    )
                }
            }
            currentDay = dayjs(currentDay).add(1, 'day')
        }
        if (onClose) {
            onClose()
        }
    }

    return (
        <>
            <div className="w-full p-2">
                <Controller
                    control={dateRangeForm}
                    name="dayOffRange"
                    render={({ field: { value, onChange } }) => {
                        return (
                            <DateRangePicker
                                values={value}
                                onChange={onChange}
                                size="small"
                                placeholder="Khoảng thời gian"
                            />
                        )
                    }}
                />
            </div>
            <div className="w-full p-2">
                <Controller
                    control={dateRangeForm}
                    name="option"
                    render={({ field: { value, onChange } }) => {
                        return (
                            <RadioGroup
                                direction="row"
                                className="flex flex-wrap align-middle justify-center"
                                value={value}
                                onChange={onChange}
                                options={[
                                    {
                                        label: 'All day',
                                        value: 2,
                                    },
                                    {
                                        label: 'Morning',
                                        value: 0,
                                    },
                                    {
                                        label: 'Afternoon',
                                        value: 1,
                                    },
                                ]}
                            />
                        )
                    }}
                />
            </div>

            <div className="w-full">
                <div className="w-full space-x-2">
                    <Button
                        className="float-end"
                        size="small"
                        variant="contained"
                        onClick={handleCreateDateRange(createRangeOptions)}
                    >
                        Generate Range Time
                    </Button>
                    <Button
                        className="float-end"
                        size="small"
                        variant="text"
                        onClick={() => onClose()}
                    >
                        Close
                    </Button>
                </div>
            </div>
        </>
    )
}

export default DayOffRangeTimeFrom
